import { SignatureService } from "../../services/signature-service";
import { ApplicationService } from "../../services/application-service";
import { BankidSignDialog } from "./bankid-sign-dialog";
import { IEventAggregator, inject, bindable, BindingMode, newInstanceForScope } from "aurelia";
import { IValidationController } from "@aurelia/validation-html";
import { IValidationRules } from "@aurelia/validation";
import { IDialogService } from "@aurelia/dialog";
import { SignatureFound } from "../../messages/signature-found";


@inject(
  IEventAggregator,
  SignatureService,
  ApplicationService,
  IDialogService,
  newInstanceForScope(IValidationController)
)
export class SignatureBoxV2CustomElement {
  @bindable email;
  @bindable referenceType;
  @bindable referenceId;
  @bindable referenceDisplay;
  @bindable formSign;

  constructor(
    eventAggregator,
    signatureService,
    applicationService,
    dialogService,
    signValidationController
  ) {
    this.ea = eventAggregator;
    this.signatureService = signatureService;
    this.applicationService = applicationService;
    this.dialogService = dialogService;
    this.signValidationController = signValidationController;

    this.signed = false;
  }


  async getSignatures() {
    const signatures = await this.signatureService.getByReferenceId(this.referenceId);
    for (const signature of signatures) {
      if (signature.email == this.email) {
        this.signed = true;
        this.fullName = signature.fullName;
        this.updated = signature.updated;
        this.bankIdOrderRef = signature.bankIdOrderRef;
      }
      this.ea.publish(new SignatureFound(signature.referenceType, signature));
    }
  }

  attached() {
    this.afterAttached();
  }

  async afterAttached() {
    if (this.formSign && !this.formSign.signed) {
      return;
    }

    await this.getSignatures();
  }

  async sign() {
    let model = {
      referenceId: this.referenceId,
      type: this.referenceType,
      referenceDisplay: this.referenceDisplay
    };

    this.dialogService
      .open({ component: () => BankidSignDialog, model })
      .whenClosed(async (response) => {
        if (response.status === 'ok') {
          setTimeout(async () => {
            await this.getSignatures();
          }, 2000);
        }
      });
  }
}

